import React, { useState } from 'react';

import styles from './rankingList.module.scss';

const Tab = (props) => {
    const { active, onTabClick, label, value } = props;
    const handleClick = () => {
        onTabClick(value);
    };
    return (
        <span
            className={`${styles.rankHeaderLink} ${active ? 'active' : ''}`}
            onClick={handleClick}
        >
            {label}
        </span>
    );
};

const TabFilters = (props) => {
    const { tabOptions, tabOptions: { tabs }, onTabChange, tabHeaderClass, tabHeaderChildren, columnStyle, filter } = props;
    const defaultTab = tabs && tabs.find(tab => tab.default);
    const [activeTab, setActiveTab] = useState(defaultTab || {});
    const [activeSubTab, setActiveSubTab] = useState(defaultTab && defaultTab.subTabs && defaultTab.subTabs.length > 0 && defaultTab.subTabs[0]);

    const handleTabChange = (value) => {
        const active = tabs.find(tab => tab.value === value);
        setActiveTab(active);
        setActiveSubTab(null);

        if (onTabChange) {
            onTabChange({
                selectedTab: active,
                selectedSubTab: null,
            });
        }
    };

    const handleSubTabChange = (value) => {
        const active = activeTab.subTabs.find(tab => tab.value === value);
        setActiveSubTab(active);
        if (onTabChange) {
            onTabChange({
                selectedTab: activeTab,
                selectedSubTab: active || null,
            });
        }
    };

    return (
        <>
            <div className={`row ${styles.rankHeaders} ${tabHeaderClass}`}>
                <div className={`${styles.rankHeaderColumn} ${columnStyle} d-grid`}>
                    {tabOptions.tabs && tabOptions.tabs.map(tab => {
                        return (
                            <Tab key={tab.value} active={activeTab.value === tab.value} label={tab.name} value={tab.value} onTabClick={handleTabChange} />
                        );
                    })}
                    {filter}
                </div>
                {tabHeaderChildren}
                {(activeTab && activeTab.subTabs) && (
                    <div className={`${styles.rankHeaderColumn} ${columnStyle} text-center mt16 `}>
                        {activeTab.subTabs.map(tab => {
                            return (
                                <Tab key={tab.value} active={activeSubTab ? activeSubTab.value === tab.value : false} label={tab.name} value={tab.value} onTabClick={handleSubTabChange} />
                            );
                        })}
                        {activeTab.subTabLink && (
                            <span
                                className={`${styles.rankHeaderLink}`}
                            >
                                <a target="_blank" rel="noopener noreferrer" href={`${activeTab.subTabLink.linkValue}`}>{activeTab.subTabLink.linkName}</a>
                            </span>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default TabFilters;
